import React from "react";

const History = ({ foodHistory, clearHistory }) => {
  return (
    <div className="view active">
      <div className="input-card">
        <div className="form-group">
          <h2 style={{ color: "white", marginBottom: "1rem" }}>
            📋 My Food History
          </h2>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              marginBottom: "1.5rem",
            }}
          >
            Track your Alpha-Gal safe food discoveries
          </p>
          {foodHistory.length > 0 && (
            <button
              onClick={clearHistory}
              className="check-btn"
              style={{
                background: "rgba(255, 0, 0, 0.2)",
                border: "1px solid rgba(255, 0, 0, 0.3)",
              }}
            >
              🗑️ Clear History
            </button>
          )}
        </div>
      </div>

      {foodHistory.length === 0 ? (
        <div className="result-card">
          <div className="result-header">
            <span className="result-icon">📝</span>
            <h3 className="result-title">No History Yet</h3>
          </div>
          <p className="result-message">
            Start checking foods to build your Alpha-Gal safe food history!
          </p>
        </div>
      ) : (
        <div className="recipe-list">
          {foodHistory.map((entry) => (
            <div key={entry.id} className="recipe-card">
              <div className="result-header">
                <span className="result-icon">
                  {entry.isSafe ? "✅" : "⚠️"}
                </span>
                <div>
                  <h3 className="recipe-title">{entry.name}</h3>
                  <p className="recipe-time">{entry.timestamp}</p>
                </div>
              </div>
              <p className="recipe-summary">{entry.details}</p>
              <div
                style={{
                  background: entry.isSafe
                    ? "rgba(0, 255, 0, 0.1)"
                    : "rgba(255, 0, 0, 0.1)",
                  padding: "0.5rem",
                  borderRadius: "8px",
                  marginTop: "1rem",
                }}
              >
                <strong>Confidence:</strong>{" "}
                {Math.round(entry.confidence * 100)}%
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default History;
